import { withStylePrefix } from '../../common/withStylePrefix';
import { ChatBubbleComponent, chatBubbleTemplate } from './ChatBubble';
import styles from './ChatBubble.styles.scss';
export const chatBubbleDefinition = {
    baseName: 'chat-bubble',
    template: chatBubbleTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonChatBubble = ChatBubbleComponent.compose(chatBubbleDefinition);
